import { Container } from "./Accordion.styled";
import { AccordionItem } from "./AccordionItem";
import { observer } from "mobx-react";
import { useStores } from "../../../stores";
import { useTranslation } from "react-i18next";

interface AccordionProps {}

export const Accordion = observer(({}: AccordionProps) => {
	const { grandCharts } = useStores();

	const { t } = useTranslation();

	return (
		<>
			<Container>
				<AccordionItem name={"the_core"} title={t("accordion.the_core")} isCore grandCharts={grandCharts.theCore} />
				<AccordionItem
					name={"skill_bundles"}
					title={t("accordion.skill_bundles")}
					grandCharts={grandCharts.skill_bundles}
				/>
				<AccordionItem name={"packs"} title={t("accordion.packs")} grandCharts={grandCharts.packs} />
			</Container>
		</>
	);
});
